export const HubspotFeatureObj = [
    {
      title: "See HubSpot contact details in CausalFunnel",
      desc: "Solve your customer cases without having to leave CausalFunnel panel.",
    },
    {
      title: "Export chat transcripts",
      desc: "Whenever you mark conversation as solved, chat transcript will be added to HubSpot as a note",
    },
    {
      title: "Map contact properties",
      desc: "Manually add contact properties to be synced with HubSpot.",
    },
    {
      title: "Automatically create contacts",
      desc: "New contacts and subscribers from CausalFunnel will be added and updated in HubSpot.",
    },
  ];
  
  export const HubspotInstallGuide = [
    { id: 1, content: "Click the button below to add a new authorization" },
    { id: 2, content: "Log in to your Hubspot account in the popup" },
    { id: 3, content: "Click the 'Allow' button" },
  ];
  